<template>
  <div class="section"><slot></slot></div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.section {
  background: #ffffff;
  margin: 0 0 24px;
  padding: 28px;
  box-sizing: border-box;
}
</style>
